// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__kSsil","detailsBorder":"styles_detailsBorder__33VWl"};